module.exports = "https://www.gc-qa.gnp.com.mx/7084e9b81d28f324d1fe5b6a3188ff26.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/dbk_reg_front_right.png
// module id = 8098
// module chunks = 0